import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import moment from 'moment';

import { CREATE_TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import CreateTransactionFormComponent from './../../components/createTransactionSummary/CreateTransactionFormComponent';
import { ReactTableColumnProperties } from 'Common/Constants';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  PrintOptionsEnum,
  PrintSortTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';

class CreateTransactionPageFormContainer extends Component {
  currentDate = moment();
  state = {
    activeIndexes: [0, 1],
    showDialog: false,
    isPreviewClicked: false,
  };
  columns = [
    { Header: 'Site Id', accessor: 'SiteId', ...ReactTableColumnProperties },
    {
      Header: 'Description',
      accessor: 'Description',
      ...ReactTableColumnProperties,
    },
    { Header: 'Status', accessor: 'Status', ...ReactTableColumnProperties },
    { Header: 'LastDate', accessor: 'LastDate', ...ReactTableColumnProperties },
  ];

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    activeIndexes.indexOf(index) !== -1
      ? activeIndexes.splice(activeIndexes.indexOf(index), 1)
      : activeIndexes.push(index);
    this.setState({ activeIndexes });
  };
  getPhysicals = () => {
    const { endDT, getPhysicalForTranSummary } = this.props;
    getPhysicalForTranSummary(
      moment(endDT, DATE_FORMAT_FOR_UI).format(DATE_FORMAT_FOR_SERVER)
    );
  };
  previewTransaction = () => {
    const {
      beginDT,
      endDT,
      printOptionsValue,
      showDetails,
      getOpenTransactionWarning,
    } = this.props;
    getOpenTransactionWarning({
      SortType:
        printOptionsValue === PrintOptionsEnum.ItemCode
          ? PrintSortTypeEnum.ItemCode
          : PrintSortTypeEnum.ItemDescription,
      ShowDetails: showDetails,
      DateBegin: moment(beginDT, DATE_FORMAT_FOR_UI).format(
        DATE_FORMAT_FOR_SERVER
      ),
      DateEnd: moment(endDT, DATE_FORMAT_FOR_UI).format(DATE_FORMAT_FOR_SERVER),
    }).then(() => {
      if (!this.props.fetchOpenTransactionWarningMsgLoadingError) {
        !this.props.showWarningDialog
          ? this.setState({ showDialog: true, isPreviewClicked: true })
          : this.setState({ isPreviewClicked: true });
      }
    });
  };
  closePeriod = () => {
    const {
      beginDT,
      endDT,
      printOptionsValue,
      showDetails,
      getOpenTransactionWarning,
    } = this.props;
    getOpenTransactionWarning({
      SortType:
        printOptionsValue === PrintOptionsEnum.ItemCode
          ? PrintSortTypeEnum.ItemCode
          : PrintSortTypeEnum.ItemDescription,
      ShowDetails: showDetails,
      DateBegin: moment(beginDT, DATE_FORMAT_FOR_UI).format(
        DATE_FORMAT_FOR_SERVER
      ),
      DateEnd: moment(endDT, DATE_FORMAT_FOR_UI).format(DATE_FORMAT_FOR_SERVER),
    }).then(() => {
      if (!this.props.fetchOpenTransactionWarningMsgLoadingError) {
        !this.props.showWarningDialog && this.setState({ showDialog: true });
      }
    });
  };
  onSubmitClick = flag => {
    if (flag) {
      const {
        beginDT,
        endDT,
        printOptionsValue,
        showDetails,
        getTranPreview,
        closePeriod,
      } = this.props;
      this.state.isPreviewClicked
        ? getTranPreview({
            SortType:
              printOptionsValue === PrintOptionsEnum.ItemCode
                ? PrintSortTypeEnum.ItemCode
                : PrintSortTypeEnum.ItemDescription,
            ShowDetails: showDetails,
            DateBegin: moment(beginDT, DATE_FORMAT_FOR_UI).format(
              DATE_FORMAT_FOR_SERVER
            ),
            DateEnd: moment(endDT, DATE_FORMAT_FOR_UI).format(
              DATE_FORMAT_FOR_SERVER
            ),
          })
        : closePeriod({
            DateBegin: moment(beginDT, DATE_FORMAT_FOR_UI).format(
              DATE_FORMAT_FOR_SERVER
            ),
            DateEnd: moment(endDT, DATE_FORMAT_FOR_UI).format(
              DATE_FORMAT_FOR_SERVER
            ),
          });
    }
    this.setState({ showDialog: false, isPreviewClicked: false });
  };
  openTransactionPrint = flag => {
    if (flag) {
      ReportGeneration(
        this.props.fetchOpenTransactionWarningMsg.Data[
          TransactionSummaryEnum.OpenTranReportString
        ],
        'Open Transaction Report'
      );
    }
    this.props.showWarningMsg(false);
    this.setState({ showDialog: true });
  };
  render() {
    const { activeIndexes, isPreviewClicked } = this.state;
    const {
      fetchExistingTranSummaryPreviewLoading,
      fetchPhysicalForTranSummaryListLoading,
      physicalForTranSummaryList,
      closePeriodLoading,
      showWarningDialog,
      fetchOpenTransactionWarningMsg,
      fromDateMax,
      toDateMin,
    } = this.props;
    return (
      <CreateTransactionFormComponent
        activeIndexes={activeIndexes}
        fromDateMax={fromDateMax}
        toDateMin={toDateMin}
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        columns={this.columns}
        getPhysicals={this.getPhysicals}
        physicalForTranSummaryList={physicalForTranSummaryList}
        fetchPhysicalForTranSummaryListLoading={
          fetchPhysicalForTranSummaryListLoading
        }
        previewTransaction={this.previewTransaction}
        fetchExistingTranSummaryPreviewLoading={
          fetchExistingTranSummaryPreviewLoading
        }
        closePeriod={this.closePeriod}
        closePeriodLoading={closePeriodLoading}
        showDialog={this.state.showDialog}
        onSubmitClick={this.onSubmitClick}
        showWarningDialog={showWarningDialog}
        fetchOpenTransactionWarningMsg={fetchOpenTransactionWarningMsg}
        openTransactionPrint={this.openTransactionPrint}
        isPreviewClicked={isPreviewClicked}
      />
    );
  }
}

export const CreateTransactionPageForm = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: CREATE_TRANSACTION_FORM_NAME,
})(CreateTransactionPageFormContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/containers/createTransaction/CreateTransactionForm.js